import AgentList from "./AgentList";

export default function AllAgentList() {
  return <AgentList allAgentsView />;
}
